export const rootElementId = "track-my-installation-root";

export const Page = {
    installation: (reference: string) => `/installation/${reference}`,
    installations: "/installations",
    otp: "/enter-otp",
    search: "/search"
};